import './color.css';

export default {};
